import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { TeamProvider } from "./teams/TeamProvider";
import { AccessProvider } from "./access/AccessProvider";
import "./styles.css";
const root = document.getElementById("root");
if (!root)
    throw new Error("Root element was not found");
createRoot(root).render(_jsx(StrictMode, { children: _jsx(AuthProvider, { children: _jsx(TeamProvider, { children: _jsx(AccessProvider, { children: _jsx(App, {}) }) }) }) }));
